import React from "react";

// Atom: Select. Options are passed as children so the atom stays data-agnostic.
const SelectInput = ({ className = "smww-select", children, ...props }) => (
    <select
        className={className}
        data-atomic="atom"
        data-atomic-name="select"
        {...props}
    >
        {children}
    </select>
);

export default SelectInput;
